<template>
  <page>
    <lazy-div>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newMode">mdi-plus</v-icon>
          <v-icon v-if="reviewMode">mdi-pencil</v-icon>
          <v-icon v-if="queryMode">mdi-magnify</v-icon>
          <v-toolbar-title v-if="newMode">New Voyage Details</v-toolbar-title>
          <v-toolbar-title v-if="reviewMode">Edit Voyage Details</v-toolbar-title>
          <v-toolbar-title v-if="queryMode">Query Voyage Details</v-toolbar-title>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text>
          <message :messages="messages"></message>
          <form>
            <v-container fluid grid-list-lg>
              <v-layout wrap>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{ labels.paramName }}</v-subheader>
                  <div class="queryValue">{{ form.paramName }}</div>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs6 v-if="newMode">
                  <v-text-field
                    :label="labels.paramType"
                    v-model="form.paramType"
                    :error-messages="errors.collect('paramType')"
                    data-vv-name="paramType"
                    :data-vv-as="labels.paramType"
                    v-validate="'required|param|max:6'"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 v-else>
                  <v-subheader class="queryLabel">{{ labels.paramType }}</v-subheader>
                  <div class="queryValue">{{ form.paramType }}</div>
                </v-flex>
                <v-flex xs6 v-if="queryMode">
                  <v-subheader class="queryLabel">{{ labels.paramDesc }}</v-subheader>
                  <div class="queryValue">{{ form.paramDesc }}</div>
                </v-flex>
                <v-flex xs6 v-else>
                  <v-text-field
                    :label="labels.paramDesc"
                    v-model="form.paramDesc"
                    :error-messages="errors.collect('paramDesc')"
                    data-vv-name="paramDesc"
                    :data-vv-as="labels.paramDesc"
                    v-validate="'required|max:120'"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 v-if="queryMode">
                  <v-subheader class="queryLabel">{{ labels.estDeptDate }}</v-subheader>
                  <div class="queryValue">{{ formatDisplayDate(form.estDeptDate) }}</div>
                </v-flex>
                <v-flex xs6 v-else>
                  <cal-picker
                    :label="labels.estDeptDate"
                    v-model="form.estDeptDate"
                    :error-messages="errors.collect('estDeptDate')"
                    data-vv-name="estDeptDate"
                    :data-vv-as="labels.estDeptDate"
                  ></cal-picker>
                </v-flex>
                <v-flex xs6 v-if="queryMode">
                  <v-subheader class="queryLabel">{{ labels.estDeptTime }}</v-subheader>
                  <div class="queryValue">{{ form.estDeptTime }}</div>
                </v-flex>
                <v-flex xs5 v-else>
                  <time-picker
                    :label="labels.estDeptTime"
                    v-model="form.estDeptTime"
                    :error-messages="errors.collect('estDeptTime')"
                    data-vv-name="estDeptTime"
                    :data-vv-as="labels.estDeptTime"
                  ></time-picker>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                  <div class="queryValue">{{ form.createdBy }}</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                  <div class="queryValue">{{ formatDisplayDate(form.createdDate) }}</div>
                </v-flex>
              </v-layout>
              <v-layout wrap v-if="!newMode">
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                  <div class="queryValue">{{ form.modifiedBy }}</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                  <div class="queryValue">{{ formatDisplayDate(form.modifiedDate) }}</div>
                </v-flex>
              </v-layout>
            </v-container>
          </form>
        </v-card-text>
        <v-flex xs12 row warp>
          <v-btn color="error" dark class=" mr-2" @click.prevent="doCancel" :loading="submitting"
            >Cancel<v-icon dark right>mdi-cancel</v-icon></v-btn
          >
          <v-btn :disabled="queryMode" color="primary" type="submit" @click.prevent="doSave" :loading="submitting">
            Save
            <v-icon right>mdi-content-save</v-icon>
          </v-btn>
        </v-flex>
      </v-card>
    </lazy-div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { formatDisplayDate, formatDisplayTime, setDateTime } from '@/utils/date'
import { expandURI } from '@/utils/ajax'
export default {
  data() {
    return {
      marineParam: 'vslVoy',
      headers: [
        { text: 'Vessel No.', value: 'paramName' },
        { text: 'Voyage No.', value: 'paramType' },
        { text: 'Description', value: 'paramDesc' },
        { text: 'Estimated Departure Date', value: 'estDeptDate' },
        { Text: 'Estimated Departure Time', value: 'estDeptTime' },
        TableConst.tableActionHeader
      ],
      labels: {
        paramName: 'Vessel No.',
        paramType: 'Voyage No.',
        paramDesc: 'Voyage Details',
        estDeptDate: 'Estimated Departure Date',
        estDeptTime: 'Estimated Departure Time',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      form: {
        paramName: '',
        paramDesc: '',
        paramType: '',
        estDeptDate: '',
        estDeptTime: '',
        createdBy: '',
        createdDate: '',
        modifiedBy: '',
        modifiedDate: ''
      },
      submitting: false,
      queryMode: false,
      reviewMode: false,
      newMode: false
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    formatDisplayTime(xTime) {
      return formatDisplayTime(xTime)
    },
    setDateTime(xdate, ytime) {
      return setDateTime(xdate, ytime)
    },
    async doFetchData() {
      this.resetValidator()
      this.resetMessages()
      const apiURI = this.menu.vslParam
      const expand = { paramKey: 'vslVoy', paramString: this.paramName, paramString2: this.paramType }
      if (apiURI) {
        this.loading = true
        this.$http
          .get(expandURI(apiURI, expand))
          .then((result) => {
            const { data } = result.data
            if (data) {
              this.form.paramName = data.vslParam.paramName
              this.form.paramType = data.vslParam.paramType
              this.form.paramDesc = data.vslParam.paramDesc
              this.form.estDeptDate = data.vslParam.estDeptDate
              this.form.estDeptTime = formatDisplayTime(data.vslParam.estDeptDate)
              this.form.createdBy = data.vslParam.createdBy
              this.form.createdDate = data.vslParam.createdDate
              this.form.modifiedBy = data.vslParam.modifiedBy
              this.form.modifiedDate = data.vslParam.modifiedDate
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doCancel() {
      this.$router.push({ name: 'vslDetReview', params: { paramName: this.paramName, vsl: this.paramName, vesselDetMode: this.detMode } })
    },
    doClose() {
      this.resetValidator()
      this.resetMessages()
      this.form.paramName = ''
      this.form.paramDesc = ''
      this.form.paramType = ''
      this.form.estDeptDate = ''
      this.form.estDeptTime = ''
      this.form.createdBy = ''
      this.form.createdDate = ''
      this.form.modifiedBy = ''
      this.form.modifiedDate = ''
    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else if (this.reviewMode) {
            if (this.form.estDeptTime === '') {
              this.form.estDeptTime = '00:00'
            }
            this.doUpdate()
            // } else {
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.createVsl
      if (apiURI) {
        const returnForm = {
          actionKey: 'vslVoy',
          paramName: this.form.paramName,
          paramType: this.form.paramType,
          paramDesc: this.form.paramDesc,
          estDeptDate: setDateTime(this.form.estDeptDate, this.form.estDeptTime)
        }
        this.$http
          .post(apiURI, returnForm)
          .then((result) => {
            const { data } = result
            if (data) {
              this.notify(data)
              this.doClose()
              this.doCancel()
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updateVsl
      if (apiURI) {
        const returnForm = {
          actionKey: 'vslVoy',
          paramName: this.form.paramName,
          paramType: this.form.paramType,
          paramDesc: this.form.paramDesc,
          estDeptDate: setDateTime(this.form.estDeptDate, this.form.estDeptTime)
        }
        this.$http
          .post(apiURI, returnForm)
          .then((result) => {
            const { data } = result
            if (data) {
              this.notify(data)
              this.doClose()
              this.doCancel()
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.marineParam.menu
    },
    modeParam() {
      return this.$route.params.vesselVoyMode
    },
    paramName() {
      return this.$route.params.paramName
    },
    paramType() {
      return this.$route.params.paramType
    },
    detMode() {
      return this.$route.params.detReview
    }
  },
  created() {
    if (this.modeParam === 'create') {
      this.form.paramName = this.paramName
      this.form.paramType = null
      this.form.paramDesc = null
      this.form.estDeptDate = ''
      this.form.estDeptTime = '00:00'
      this.form.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
      this.form.createdDate = new Date()
      this.newMode = true
    } else if (this.modeParam === 'query') {
      this.doFetchData()
      this.queryMode = true
    } else {
      this.doFetchData()
      this.reviewMode = true
    }
  },
  mixins: [MessageMixin],
  watch: {
    'form.estDeptTime': function () {
      if (this.form.estDeptTime === null || this.form.estDeptTime === '') {
        this.form.estDeptTime = '00:00'
      } else {
        this.form.estDeptTime = this.form.estDeptTime
      }
    }
  }
}
</script>
